/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import TransactionMetaDTO from './TransactionMetaDTO';





/**
* The TransactionInfoDTO model module.
* @module model/TransactionInfoDTO
* @version 0.7.15
*/
export default class TransactionInfoDTO {
    /**
    * Constructs a new <code>TransactionInfoDTO</code>.
    * @alias module:model/TransactionInfoDTO
    * @class
    * @param meta {module:model/TransactionMetaDTO} 
    * @param transaction {Object} 
    */

    constructor(meta, transaction) {
        

        
        

        this['meta'] = meta;this['transaction'] = transaction;

        
    }

    /**
    * Constructs a <code>TransactionInfoDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/TransactionInfoDTO} obj Optional instance to populate.
    * @return {module:model/TransactionInfoDTO} The populated <code>TransactionInfoDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TransactionInfoDTO();

            
            
            

            if (data.hasOwnProperty('meta')) {
                obj['meta'] = TransactionMetaDTO.constructFromObject(data['meta']);
            }
            if (data.hasOwnProperty('transaction')) {
                obj['transaction'] = ApiClient.convertToType(data['transaction'], Object);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/TransactionMetaDTO} meta
    */
    meta = undefined;
    /**
    * @member {Object} transaction
    */
    transaction = undefined;








}


